import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdErrorOutline } from "react-icons/md";
import CarrierModal from "../CarrierModal";

const DisconnectDialog = ({ row, onConfirm, onClose }) => {
  const { t } = useTranslation("settings");
  const [working, setWorking] = useState(false);

  const handleConfirm = async () => {
    setWorking(true);
    const removed = await onConfirm(row);
    setWorking(false);
    if (removed) onClose();
  };

  return (
    <CarrierModal
      onClose={working ? undefined : onClose}
      boxClassName="max-w-[92%] !rounded-[14px] text-center shadow-ui-md"
    >
      <MdErrorOutline className="mx-auto h-11 w-11 text-state-danger-solid" />
      <p className="mt-2.5 text-base font-medium text-ui-text">
        {t("carriers.disconnect.question")}
      </p>
      {row.account_name && (
        <p className="mt-1 text-[13px] text-ui-text-muted">{row.account_name}</p>
      )}
      <div className="mt-5 flex justify-center gap-2.5">
        <button
          type="button"
          onClick={onClose}
          disabled={working}
          className="h-[38px] flex-1 rounded-lg border border-ui-border bg-ui-surface text-[13px] text-ui-text sm:w-[120px] sm:flex-none"
        >
          {t("common:actions.cancel")}
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={working}
          className="h-[38px] flex-1 rounded-lg bg-state-danger-solid text-[13px] font-medium text-white disabled:cursor-wait disabled:opacity-60 sm:w-[120px] sm:flex-none"
        >
          {working ? t("carriers.disconnect.working") : t("carriers.disconnect.action")}
        </button>
      </div>
    </CarrierModal>
  );
};

export default DisconnectDialog;
